import {Stack, Tooltip} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

export type DataGridColumnHeaderInfoProps = {
    title: string;
    /** Explains the column; shown in a tooltip over the title and its help icon. */
    info: string;
};

/** A column title with a help icon and a tooltip, for `renderHeader`. Clicking the icon does not sort the column. */
export function DataGridColumnHeaderInfo({
                                             title,
                                             info,
                                         }: DataGridColumnHeaderInfoProps) {
    return (
        <Tooltip title={info}>
            <Stack component="span" direction="row" alignItems="center" gap={0.5}>
                {title}
                <Stack
                    component="span"
                    aria-label={info}
                    onMouseDown={event => event.stopPropagation()}
                    onClick={event => event.stopPropagation()}
                    sx={{color: 'text.secondary', lineHeight: 0}}
                >
                    <HelpOutlineIcon sx={{fontSize: 16}}/>
                </Stack>
            </Stack>
        </Tooltip>
    );
}
